import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { useOccAssets } from '@vista-digital/occ-ui/src/lib/context'
import { useOccAccessibilityText } from '@vista-digital/occ-ui/src/lib/context/occ/hooks/use-occ-accessibility-text'
import { Icon } from '@vista-digital/occ-ui/src/lib/subcomponents/icon'

export interface CarouselScrollButtonProps {
    disabled: boolean
    direction: 'previous' | 'next'
    onClick: VoidFunction
}

const b = bemClassBuilder('v-carousel-scroll-button')

export const CarouselScrollButton: React.FC<CarouselScrollButtonProps> = props => {
    const { disabled, direction, onClick } = props
    const { carouselPreviousButtonIconName, carouselNextButtonIconName } = useOccAssets()
    const { carouselPreviousButtonAriaLabel, carouselNextButtonAriaLabel } = useOccAccessibilityText()
    const isPreviousButton = direction === 'previous'
    const iconName = isPreviousButton ? carouselPreviousButtonIconName : carouselNextButtonIconName
    const ariaLabel = isPreviousButton ? carouselPreviousButtonAriaLabel : carouselNextButtonAriaLabel

    return (
        <button
            className={b.block({ [direction]: true, disabled: disabled })}
            onClick={onClick}
            disabled={disabled}
            aria-label={ariaLabel}
        >
            <Icon name={iconName} />
        </button>
    )
}

CarouselScrollButton.displayName = 'CarouselScrollButton'
